import loaderInd from 'assets/images/loader-ind.gif';
import styled, { css } from 'theme';

export const LoaderContainer = styled.div<{ fullScreen?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.fullScreen &&
    css`
      position: absolute;
      top: calc(50% - 92px);
      align-self: center;
    `}
`;

export const LoaderImage = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  margin: 4rem;
  background: url(${loaderInd}) no-repeat center center;
  background-size: 3.5rem;
`;
